"use strict";

/* $(window).on('load', function() {
    if ($('body').hasClass('template-product')) {
        productGallery();
    }
}); */

document.addEventListener('DOMContentLoaded', function () {
  if ($('body').hasClass('template-product')) {
    productGallery();
    stickyAddToCart();
  }
}, false);
var clonedProductGalleryWrapper;
var productSliderNavBlocked = false;
function productGallery() {
  var productGalleryWrapper = $('.product-gallery-wrapper');
  var productThumbnail = productGalleryWrapper.find('.product-gallery-slide');
  var currentNumber = productGalleryWrapper.next().find('.current-slide');
  clonedProductGalleryWrapper = productGalleryWrapper.html();
  productGalleryWrapper.on('init', function (event, slick, currentSlide, nextSlide) {
    currentNumber.text('01');
    productGalleryWrapper.find(".slick-slide").css("opacity", "1");
  }).on('beforeChange', function (event, slick, currentSlide, nextSlide) {
    var currentSlideNumber = nextSlide + 1;
    if (currentSlideNumber >= 0 && currentSlideNumber <= 9) {
      var currentSlideNumber = '0' + currentSlideNumber;
    }
    currentNumber.text(currentSlideNumber);
  }).slick({
    centerMode: true,
    centerPadding: '0px',
    slidesToShow: 1,
    focusOnSelect: true,
    arrows: true,
    appendArrows: '.product_slider .carousel-wrap',
    infinite: true
  });
  $(".product_slider .next_prev_ext > div").click(function (e) {
    if ($(this).hasClass("prev_ext")) productGalleryWrapper.slick('slickPrev');else productGalleryWrapper.slick('slickNext');
  });
  productThumbnail.on('mousedown', function (evt) {
    productThumbnail.on('mouseup mousemove', function handler(evt) {
      if (evt.type === 'mouseup') {
        var activeSlide = $(this).attr('data-slick-index');
        var activeSlide = $(this).attr('data-slick-index');
        createPopupGallery(activeSlide);
      }
      productThumbnail.off('mouseup mousemove', handler);
    });
  });
}
function createPopupGallery(activeSlide) {
  var popup = $(".product-gallery-popup");
  var popupDivContent = '<div class="popup-gallery-slider">' + clonedProductGalleryWrapper + '</div>';
  popup.append(popupDivContent);
  var popupGallery = $('.popup-gallery-slider');
  popup.addClass('open-modal');
  popupGallery.on('init setPosition resize', function () {
    if ($(window).width() > 767) popupGallery.find(".slick-slide").height($(window).height() - 80);
  }).slick({
    slidesToShow: 1,
    focusOnSelect: true
    // variableWidth: true,
  });

  popupGallery.slick("slickGoTo", activeSlide, true);
  popup.find("a.close-btn").click(function (e) {
    e.preventDefault();
    popup.removeClass('open-modal');
    popupGallery.remove();
  });
}

//sticky add to cart
var _atc_pos, formWrapper;
function stickyAddToCart() {
  if ($(window).width() < 768) {
    formWrapper = $(".product-form-wrapper");
    _atc_pos = 800;
    var checker;
    checker = setInterval(function () {
      if ($(".product_slider .product-gallery-wrapper").hasClass("slick-initialized")) {
        clearInterval(checker);
        _atc_pos = formWrapper.offset().top + 100;
        $(window).scroll(function () {
          stickyATC();
        });
        stickyATC();
      }
    }, 300);
  }
}
function stickyATC() {
  //console.log($(window).scrollTop() , _atc_pos , !formWrapper.hasClass('sticky'))
  if ($(window).scrollTop() > _atc_pos && !formWrapper.hasClass('sticky')) {
    formWrapper.addClass('sticky');
    setTimeout(function () {
      $(".product-form-wrapper form.product-form").addClass("show-me");
    }, 300);
  } else if ($(window).scrollTop() <= _atc_pos && formWrapper.hasClass('sticky')) {
    $(".product-form-wrapper form.product-form").removeClass("show-me");
    setTimeout(function () {
      formWrapper.removeClass('sticky');
    }, 300, formWrapper);
  }
}